"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDefaultPopupContainerClass = exports.setMessageLocalizer = exports.setNumberLocalizer = exports.setDateLocalizer = void 0;
exports.setLocalizers = setLocalizers;
const localizers_1 = require("./localizers");
const widget_helpers_1 = require("./widget-helpers");
exports.setDateLocalizer = localizers_1.setDate;
exports.setNumberLocalizer = localizers_1.setNumber;
exports.setMessageLocalizer = localizers_1.setMessage;
exports.setDefaultPopupContainerClass = widget_helpers_1.setDefaultPopupContainerClass;
function setLocalizers({ date, number, message }) {
    if (date) {
        (0, exports.setDateLocalizer)(date);
    }
    if (number) {
        (0, exports.setNumberLocalizer)(number);
    }
    if (message) {
        (0, exports.setMessageLocalizer)(message);
    }
}
exports.default = {
    setDateLocalizer: exports.setDateLocalizer,
    setNumberLocalizer: exports.setNumberLocalizer,
    setMessageLocalizer: exports.setMessageLocalizer,
    setLocalizers,
    setDefaultPopupContainerClass: exports.setDefaultPopupContainerClass
};
//# sourceMappingURL=configure.js.map